// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__25lz6","header":"MessagesList_header__1aGrW","chat":"MessagesList_chat__Da2Yv"};